import {AbstractControl} from "@angular/forms";

export class SharedValidators {
    static customRequired(control: AbstractControl) {
        if (control.dirty && !control.value) {
            return {customRequired: true};
        }

        return null;
    }

    static customNumberRequired(control: AbstractControl) {
        if (control.dirty && control.value == null) {
            return {customRequired: true};
        }

        return null;
    }


}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/shared-validators.ts